module.exports = __webpack_public_path__ + "static/img/file-icon.38d167c9.svg";